"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionOverlayController = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var model_1 = require("../../../model");
var refs_1 = require("../refs");
var DashboardItemOverlay_1 = require("./DashboardItemOverlay");
exports.DashboardLayoutSectionOverlayController = function (props) {
    var section = props.section;
    var dispatch = model_1.useDashboardDispatch();
    var refs = refs_1.getRefsForSection(section);
    var overlayShow = model_1.useDashboardSelector(model_1.selectWidgetsOverlayState(refs));
    var sectionModifications = model_1.useDashboardSelector(model_1.selectSectionModification(refs));
    return (react_1.default.createElement(DashboardItemOverlay_1.DashboardItemOverlay, { type: "column", onHide: function () {
            return dispatch(model_1.uiActions.toggleWidgetsOverlay({
                refs: section.items().map(function (item) { return item.ref(); }),
                visible: false,
            }));
        }, render: overlayShow, modifications: sectionModifications }));
};
//# sourceMappingURL=DashboardItemOverlayController.js.map